module.exports = __webpack_public_path__ + "ce731cd1bc3e7735fd6242aba617fdab.mp3";


//////////////////
// WEBPACK FOOTER
// ./static/audios/4000_l_20.mp3
// module id = 439
// module chunks = 0